import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { LegalService, LegalLanguage } from '@/core/services/legalService';

export function useFooterDisclaimer() {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language?.split('-')[0] || 'en') as LegalLanguage;

  const { data, isLoading, error } = useQuery({
    queryKey: ['legal-document', 'disclaimer', lang],
    queryFn: () => LegalService.getLegalDocument('disclaimer', lang),
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });

  // Fallback sur la traduction i18n si l'API échoue
  const fallbackContent = t('footer.content');

  return {
    content: data?.content || fallbackContent,
    isLoading,
    error,
  };
}
